<!--suppress ALL -->
<template>
    <nav :class="className">
        <ul>
            <li v-if="$scopedSlots.pre || $slots.pre"><slot name="pre"></slot></li>
            <li v-for="(link, index) in links" :key="`link-${index}`">
                <g-link :to="link.to">{{link.name}}</g-link>
            </li>
            <li v-if="$scopedSlots.after || $slots.after"><slot name="after"></slot></li>
        </ul>
    </nav>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'annotation';
    import GLink from '../link/GLink.vue';

    @Component({components: {GLink}})
    export default class GBreadcrumb extends Vue {

        @Prop({default: []})
        public links: Array<any>;

        @Prop({default: ''})
        public position: string;

        @Prop({default: ''})
        public size: string;

        @Prop({default: ''})
        public separator: string;

        public get className() {
            const {position, size, separator} = this;
            const positionClassName = position ? ('is-' + position) : '';
            const sizeClassName = size ? ('is-' + size) : '';
            const separatorClassName = separator ? ('has-' + separator + '-separator') : '';

            return [positionClassName, sizeClassName, separatorClassName]
                .reduce((accu, item) => accu + (item ? (item + ' ') : ''), 'breadcrumb g-breadcrumb ');
        }
    }
</script>
